<template>
    <div class="faceRecognitionView">
        <el-dialog title="人脸识别" :visible="showState" :close-on-click-modal="false" :close-on-press-escape="false"
            width="800px" @close="close">
            <div class="content d-flex d-flex-top d-flex-between">
                <div class="leftBox">
                    <video ref="video" autoplay></video>
                    <div class="box"></div>
                    <el-button type="primary" @click="photograph">拍照</el-button>
                </div>
                <div class="rightBox">
                    <div class="exampleBox">
                        <div class="imgBox d-flex d-flex-middle d-flex-center">
                            <canvas ref="canvas" width="300" height="380"></canvas>
                        </div>
                        <p>我的图片</p>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'faceRecognition',
    props: {
        type: {
            default: ''
        }
    },
    data() {
        return {
            showState: false,
            data: {}
        }
    },
    methods: {
        open(data) {
            if (data) {
                this.data = data
            }
            this.callCamera()
        },
        close() {
            let ctx = this.$refs['canvas'].getContext('2d')
            ctx.clearRect(-90, 0, 480, 380)
            this.closeCamera()
            this.showState = false
        },
        // 调用摄像头
        callCamera() {
            this.showState = true
            // H5调用电脑摄像头API
            if (navigator.getUserMedia && navigator.mediaDevices.getUserMedia) {

                navigator.mediaDevices.getUserMedia({
                    video: true
                }).then(success => {
                    // 摄像头开启成功
                    this.$refs['video'].srcObject = success
                    // 实时拍照效果
                    this.$refs['video'].play()
                }).catch(error => {
                    if (error.name) {
                        this.showState = false
                        this.error(error)
                    }
                })
            } else {
                this.showState = false
                this.$message.error('访问摄像头失败，请检查设备及权限')
            }

        },
        error(error) {
            var errStr = "";
            if (error.name == "NotReadableError") {
                errStr = "NotReadableError，原因：读取错误，一般是摄像头隐私或麦克风隐私阻止了，或者是软件拦截了"
            } else if (error.name == "NotFoundError") {
                errStr = "NotFoundError，原因：没有发现摄像头"
            } else if (error.name == "NotAllowedError") {
                errStr = "NotFoundError，原因：启动时点击了阻止"
            }
            this.$alert('检测到异常 [' + errStr + ']，请刷新后重试！', {
                showClose: false,
                confirmButtonText: '知道了',
                type: 'error',
                callback: action => {

                }
            });
        },
        // 拍照
        photograph() {
            const _this = this
            var that = this
            let ctx = this.$refs['canvas'].getContext('2d')
            // 把当前视频帧内容渲染到canvas上
            ctx.drawImage(this.$refs['video'], -90, 0, 480, 380)
            // 转base64格式、图片格式转换、图片质量压缩---支持两种格式image/jpeg+image/png
            let imgBase64 = this.$refs['canvas'].toDataURL('image/jpeg')
            // 
            // const fileName = Date.now()+'.png'
            // const file = this.base64toFile(imgBase64,fileName)
            // let formdata = new FormData()
            // formdata.append('file', file)
            // this.$http.post('/user/common/upload.do', formdata, { 'Content-Type': 'multipart/form-data' }).then((res) => {})
            // 
            if (this.type == 'kj') { //课件
                _this.$http.post('/student/pc/common/uploadImage', { base64Image: imgBase64 }).then(res => {
                    _this.$http.post('/student/pc/courseware/facVerify', { img: res, ..._this.data }).then((res) => {
                        if (res) {
                            _this.close()
                            _this.$emit('submit')
                        } else {
                            _this.$message.error(res.msg)
                        }
                    })
                })
            }else if(this.type == 'paper'){
                that.$http.post('/student/pc/common/uploadImage', { base64Image: imgBase64}).then((r) => {
                    that.$http.post('/student/pc/paper/faceVerify', { photoPath: r, ...this.data }).then((res) => {
                        console.log(res);
                        if (res) {
                            that.close()
                            that.$emit('submit')
                        } else {
                            that.$message.error(res.msg)
                        }
                    })
                })
            }else if(this.type == 'zxdb'){
                that.$http.post('/student/pc/common/uploadImage', { base64Image: imgBase64}).then((r) => {
                    that.$http.post('/student/thesis2/faceVerify/saveCapturePhoto', { captureUrl: r, ...this.data },{isQs:1}).then((res) => {
                        console.log(res);
                        if (res) {
                            that.close()
                            that.$emit('submit')
                        } else {
                            that.$message.error(res.msg)
                        }
                    })
                })
            }


            /**------------到这里为止，就拿到了base64位置的地址，后面是下载功能----------*/

            // 由字节转换为KB 判断大小
            // let str = imgBase64.replace('data:image/jpeg;base64,', '')
            // let strLength = str.length
            // let fileLength = parseInt(strLength - (strLength / 8) * 2)　　　 // 图片尺寸  用于判断
            // let size = (fileLength / 1024).toFixed(2)
            // console.log(size) 　　  // 上传拍照信息  调用接口上传图片
        },
        base64toFile(base64Data, fileName) {
            var arr = base64Data.split(',');
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], fileName, { type: mime });
        },
        // 关闭摄像头
        closeCamera() {
            if (!this.$refs['video'].srcObject) return
            let stream = this.$refs['video'].srcObject
            let tracks = stream.getTracks()
            tracks.forEach(track => {
                track.stop()
            })
            this.$refs['video'].srcObject = null
        },
    }
}
</script>
<style lang="scss" scoped>
.faceRecognitionView {
    .content {
        width: 100%;

        .leftBox {
            width: 520px;
            text-align: center;
            position: relative;

            .box {
                position: absolute;
                border: 2px solid #ee4545;
                left: 50%;
                top: 0;
                transform: translateX(-50%);
                width: 300px;
                height: 360px;
                z-index: 999;
                box-sizing: border-box;
            }

            video {
                width: 480px;
                height: 360px;
                margin-bottom: 30px;
            }
        }

        .rightBox {
            width: 280px;
            text-align: center;

            .exampleBox {
                margin-bottom: 30px;

                .imgBox {
                    width: 180px;
                    height: 216px;
                    overflow: hidden;
                    margin: 0 auto;
                    border-radius: 5px;
                    overflow: hidden;
                    border: 1px solid #eee;
                    margin-bottom: 10px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                canvas {
                    transform: scale(0.6);
                }
            }
        }
    }
}
</style>